export namespace ClientConstant {
  export enum Clients {
    HideawaySaratoga = 53,
  }

  export enum ClientSource {
    Assets = 1,
    AzureBlob = 2,
    Database = 3,
  }
}
